export default {
    props: {
        input: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        firstStep: {
            type: Boolean,
            default: false,
        },
        lastStep: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        formData: null,
    }),

    validations: {
        formData: {},
    },

    methods: {
        getFormData() {
            return this.formData;
        },

        handleSubmit() {
            this.$v.$touch();

            if (this.$v.$pending || this.$v.$error) {
                this.$nextTick(() => {
                    this.$scrollTo('.parsley-errors-list', 500, {
                        offset: -200,
                    });
                });
                return;
            }

            this.$emit('submit', this.formData, true);
        },

        handleInput() {
            Object.keys(this.formData).forEach((key) => {
                this.formData[key] = this.input[key] || this.formData[key];
            });
        },
    },

    watch: {
        input() {
            this.handleInput();
        },
    },

    mounted() {
        this.handleInput();
    },
};
